import React, { useEffect, useState } from 'react'
import './perfilesAgendate.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapLocation, faTimesCircle, faChevronLeft, faCheckDouble, faEnvelopeCircleCheck, faBell } from '@fortawesome/free-solid-svg-icons'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Paginador } from '../Paginacion/Paginador';

const PerfilesAgendate = ({ propsPerfil }) => {

    const [modalInfo, setModalInfo] = useState(false)

    const [agendaValueSelected, setAgendaValueSelected] = useState({
        dia: '',
        fecha: '',
        hora: ''
    })

    const [formStateValue, setformStateValue] = useState({
        noDocumento: '',
        nombres: '',
        apellidos: '',
        correo: '',
        correoConfirma: '',
        telefono: '',
        observaciones: ''
    })

    const [formState, setformState] = useState({
        noDocumentoRef: false,
        nombresRef: false,
        apellidosRef: false,
        correoRef: false,
        correoConfirmaRef: false,
        telefonoRef: false,
    })

    const {
        noDocumento,
        nombres,
        apellidos,
        correo,
        correoConfirma,
        telefono,
        observaciones } = formStateValue;

    const {
        noDocumentoRef,
        nombresRef,
        apellidosRef,
        correoRef,
        correoConfirmaRef,
        telefonoRef } = formState;

    const [classAnimateFlujo, setClassAnimateFlujo] = useState({
        classPage1: 'div-info-agendate div-info-agendate-1 div-width-100',
        classPage2: 'div-info-agendate div-info-agendate-2 div-width-100',
        classPage3: 'div-info-agendate div-info-agendate-3 div-width-100',
    })

    const { classPage1, classPage2, classPage3 } = classAnimateFlujo

    const changeInput = (e) => {
        setformStateValue({
            ...formStateValue,
            [e.target.name]: e.target.value
        })
    }

    const agendaDisponible = [
        [
            {
                dia: 'Hoy', fecha: '8/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
                    '14:00', '15:00', '16:00', '17:00', '18:00'
                ]
            },
            {
                dia: 'Mañana', fecha: '9/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00'
                ]
            },
            {
                dia: 'Viernes', fecha: '10/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '14:00', '15:00', '16:00', '17:00', '18:00'
                ]
            },
            {
                dia: 'Sabado', fecha: '11/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
                    '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'
                ]
            },
        ],
        [
            {
                dia: 'Domingo', fecha: '12/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
                    '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'
                ]
            },
            {
                dia: 'Lunes', fecha: '13/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '14:00', '15:00', '16:00', '17:00', '18:00'
                ]
            },
            {
                dia: 'Martes', fecha: '14/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
                    '14:00', '15:00', '16:00', '17:00', '18:00'
                ]
            },
            {
                dia: 'Miercoles', fecha: '15/Oct',
                horas: [
                    '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00'
                ]
            },
        ]
    ]

    const [modalInfoAgenda, setModalInfoAgenda] = useState(false)

    const [paginacion, setPaginacion] = useState(
        { totalElementos: '0', elementosPorPagina: '1', paginaActual: '1' }
    );
    const [executeConsulta, setExecuteConsulta] = useState(true)

    useEffect(() => {
        setPaginacion({
            ...paginacion,
            totalElementos: agendaDisponible.length
        })
    }, [executeConsulta])

    const consultaUbicacionMaps = (estructureAddress) => {
        const urlMaps = 'https://www.google.com/maps/search/?api=1&query=' + estructureAddress;
        window.open(urlMaps, '_blank');
    }

    const renderizadoTag = () => {
        if (propsPerfil.tipoNegocio === 'NEGOCIO_1') {
            return (
                <div className='div-info-perfil-tag-1'>
                    <p className='p-element-target-landing-2 p-tag' >S. Salud</p>
                </div>
            )
        } else if (propsPerfil.tipoNegocio === 'NEGOCIO_2') {
            return (
                <div className='div-info-perfil-tag-2'>
                    <p className='p-element-target-landing-2 p-tag' >S. Belleza</p>
                </div>
            )
        } else if (propsPerfil.tipoNegocio === 'NEGOCIO_3') {
            return (
                <div className='div-info-perfil-tag-3'>
                    <p className='p-element-target-landing-2 p-tag' >S. Veterinarios</p>
                </div>
            )
        } else {
            return (
                <div className='div-info-perfil-tag-1'>
                    <p className='p-element-target-landing-2 p-tag' > -- </p>
                </div>
            )
        }
    }

    const handleCloseInfoAgenda = () => {
        activaFlujoAgendate('')
        setPaginacion({
            ...paginacion,
            paginaActual: '1'
        })
        setModalInfoAgenda(false)
    };

    const seleccionaAgenda = (agenda, hora) => {
        setAgendaValueSelected({
            dia: agenda.dia,
            fecha: agenda.fecha,
            hora: hora
        })
        activaFlujoAgendate('PAGE_2')
    }

    const avanzaFormularioClienteAction = () => {
        let formValidado = [];
        setformState({
            noDocumentoRef: false,
            nombresRef: false,
            apellidosRef: false,
            correoRef: false,
            correoConfirmaRef: false,
            telefonoRef: false,
        })

        if (noDocumento.length === 0) {
            formValidado.push('noDocumentoRef');
        }
        if (nombres.length === 0) {
            formValidado.push('nombresRef');
        }

        if (apellidos.length === 0) {
            formValidado.push('apellidosRef');
        }

        if (correo.length === 0) {
            formValidado.push('correoRef');
        } else {
            if (correoConfirma.length === 0) {
                formValidado.push('correoConfirmaRef');
            } else {
                if (correo !== correoConfirma) {
                    formValidado.push('correoRef');
                    formValidado.push('correoConfirmaRef');
                }
            }
        }

        if (correoConfirma.length === 0) {
            formValidado.push('correoConfirmaRef');
        }

        if (telefono.length === 0) {
            formValidado.push('telefonoRef');
        }

        if (formValidado.length === 0) {
            activaFlujoAgendate('PAGE_3')
        } else {
            setformState({
                noDocumentoRef: formValidado.includes('noDocumentoRef'),
                nombresRef: formValidado.includes('nombresRef'),
                apellidosRef: formValidado.includes('apellidosRef'),
                correoRef: formValidado.includes('correoRef'),
                correoConfirmaRef: formValidado.includes('correoConfirmaRef'),
                telefonoRef: formValidado.includes('telefonoRef'),
            })
            formValidado.splice(0, formValidado.length)
        }
    }

    const confirmaCitaAgendaTe = () => {
        resetForm()
        setModalInfo(true)
    }

    const resetForm = () => {
        setAgendaValueSelected({
            dia: '',
            fecha: '',
            hora: ''
        })
        setformStateValue({
            noDocumento: '',
            nombres: '',
            apellidos: '',
            correo: '',
            correoConfirma: '',
            telefono: '',
            observaciones: ''
        })
        handleCloseInfoAgenda()
    }

    const activaFlujoAgendate = (page) => {
        switch (page) {
            case 'PAGE_1':
                setClassAnimateFlujo({
                    classPage1: 'div-info-agendate div-info-agendate-1 div-width-100',
                    classPage2: 'div-info-agendate div-info-agendate-2 div-width-100',
                    classPage3: 'div-info-agendate div-info-agendate-3 div-width-100',
                })
                break
            case 'PAGE_2':
                setClassAnimateFlujo({
                    classPage1: 'div-info-agendate div-info-agendate-1 div-width-0',
                    classPage2: 'div-info-agendate div-info-agendate-2 div-width-100',
                    classPage3: 'div-info-agendate div-info-agendate-3 div-width-100',
                })
                break
            case 'PAGE_3':
                setClassAnimateFlujo({
                    classPage1: 'div-info-agendate div-info-agendate-1 div-width-0',
                    classPage2: 'div-info-agendate div-info-agendate-2 div-width-0',
                    classPage3: 'div-info-agendate div-info-agendate-3 div-width-100',
                })
                break
            default:
                setClassAnimateFlujo({
                    classPage1: 'div-info-agendate div-info-agendate-1 div-width-100',
                    classPage2: 'div-info-agendate div-info-agendate-2 div-width-100',
                    classPage3: 'div-info-agendate div-info-agendate-3 div-width-100',
                })
        }
    };

    const handleCloseInfo = () => {
        setModalInfo(false)
    };

    return (
        <>
            <div className="div-info-perfil-container" >
                {
                    renderizadoTag()
                }
                <div className='div-info-perfil-agendate'>
                    <div className='div-image-perfil-agendate'>
                        <div>
                            <img src={propsPerfil.imageProfile} className='image-perfil-agendate' />
                        </div>
                    </div>
                    <div className='div-text-info-perfil-agendate'>
                        <h1 className='size-name-profile-agendate'>
                            <span className='p-bold'>{propsPerfil.nombre} </span>
                        </h1>
                        <p className='p-element-target-landing-2 p-bold' > {propsPerfil.profesion} </p>
                        <p className='p-element-target-landing-2' >{propsPerfil.detalleProfesion}</p>
                        <p className='p-element-target-landing-2' >{propsPerfil.ubicacion}</p>
                    </div>
                </div>
                <div className='div-buttons-perfil-agendate'>
                    <button className='bottom-custom' onClick={() => setModalInfoAgenda(true)} >
                        Ver agenda
                    </button>
                    {
                        /*
                        <button className='bottom-custom-secondary' onClick={() => { }} >
                            Enviar mensaje
                        </button>
                        */
                    }
                </div>
            </div>
            <Modal isOpen={modalInfoAgenda} onHide={handleCloseInfoAgenda} className='modal-perfil-cliente'>
                <div className='div-header-info-agendate'>
                    <h4>Agendate con: </h4>
                    <FontAwesomeIcon className='icons-close-agenda' icon={faTimesCircle} onClick={handleCloseInfoAgenda} />
                </div>
                <hr />
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4" >
                        <div className='div-container-info-row-init'>
                            <h4>{propsPerfil.nombre} </h4>
                            <button className='btn btn-link bottom-custom-link' onClick={() => consultaUbicacionMaps(propsPerfil.direccion)}>
                                <FontAwesomeIcon className='icons-table-ds' icon={faMapLocation} /><p className='mx-2'> {propsPerfil.direccion} </p>
                            </button>
                        </div>
                        <hr className='hr-responsive' />
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-8" >
                        <div className="div-muestra-info-agenda-container">
                            <div className={classPage1} >
                                <div className='div-container-agenda-disponible'>
                                    <div className="row m-0 div-row-agenda-disponible div-row-agenda-disponible-header">
                                        {
                                            agendaDisponible[paginacion.paginaActual - 1].map((agenda) => (
                                                <div className="col-3 col-sm-3 col-md-3 col-lg-3" >
                                                    <div className='div-header-agenda-disponble'>
                                                        <p className='p-element-target-landing-2 p-bold' > {agenda.dia} </p>
                                                        <p className='p-element-target-landing-2' >{agenda.fecha} </p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className="row m-0 div-row-agenda-disponible">
                                        {
                                            agendaDisponible[paginacion.paginaActual - 1].map((agenda) => (
                                                <div className="col-3 col-sm-3 col-md-3 col-lg-3" >
                                                    <div className='div-header-agenda-disponble'>
                                                        {
                                                            agenda.horas.map((hora) => (
                                                                <>
                                                                    <div className='div-hora-agendate-disponible' onClick={() => seleccionaAgenda(agenda, hora)}>
                                                                        {hora}
                                                                    </div>
                                                                </>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className='div-row-agenda-disponible-buttoms'>
                                    <Paginador elementsPaginacion={paginacion} setElementsPaginacion={setPaginacion}
                                        setExecuteConsulta={setExecuteConsulta} executeConsulta={executeConsulta} />
                                </div>
                            </div>
                            <div className={classPage2} >
                                <div className='div-info-agendate-bloque'>
                                    <div className='div-formulario-cliente-step-2'>
                                        <div className='div-titulo-info-page-2'>
                                            <FontAwesomeIcon className='icons-volver-agenda' icon={faChevronLeft} onClick={() => activaFlujoAgendate('PAGE_1')} />
                                            <h1 className='size-landing-h2 titulo-form-page-2'>Datos del cliente:</h1>
                                        </div>

                                        <p className='p-label-form'> No de documento: </p>
                                        <input type="text" name='noDocumento' className={noDocumentoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                            value={noDocumento} onChange={changeInput} />

                                        <p className='p-label-form'> Nombres: </p>
                                        <input type="text" name='nombres' className={nombresRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                            value={nombres} onChange={changeInput} />

                                        <p className='p-label-form'> Apellidos: </p>
                                        <input type="text" name='apellidos' className={apellidosRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                            value={apellidos} onChange={changeInput} />

                                        <p className='p-label-form'> Correo electrónico: </p>
                                        <input type="text" name='correo' className={correoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                            value={correo} onChange={changeInput} />

                                        <p className='p-label-form'> Confirmar correo electrónico: </p>
                                        <input type="text" name='correoConfirma' className={correoConfirmaRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                            value={correoConfirma} onChange={changeInput} />

                                        <p className='p-label-form'> Número celular: </p>
                                        <input type="text" name='telefono' className={telefonoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                            value={telefono} onChange={changeInput} />
                                    </div>
                                    <div className='div-buttoms-formulario-clientes'>
                                        <button className='bottom-custom-secondary' onClick={() => avanzaFormularioClienteAction()} >
                                            Avanzar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={classPage3}>
                                <div className='div-info-agendate-bloque'>
                                    <div className='div-formulario-cliente-step-2'>
                                        <div className='div-titulo-info-page-2'>
                                            <FontAwesomeIcon className='icons-volver-agenda' icon={faChevronLeft} onClick={() => activaFlujoAgendate('PAGE_2')} />
                                            <h1 className='size-landing-h2 titulo-form-page-2'>¡Tu cita está casi lista!</h1>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row m-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                            <div className='div-info-agenda-step-3'>
                                                <p className='p-label-info-text font-size-info-agenda'>{agendaValueSelected.dia} </p>
                                                <p className='p-label-info-text font-size-info-agenda'>{agendaValueSelected.fecha} </p>
                                                <p className='p-label-info-text font-size-info-agenda'>{agendaValueSelected.hora} Hrs.</p>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                            <div className='div-info-item-step-3'>
                                                <p className='p-label-info-text'>Nombre:</p>
                                                <p className='p-label-info'>{nombres} {apellidos}</p>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                            <div className='div-info-item-step-3'>
                                                <p className='p-label-info-text'>Correo:</p>
                                                <p className='p-label-info'>{correo}</p>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                            <div className='div-info-item-step-3'>
                                                <p className='p-label-info-text'>Telefono:</p>
                                                <p className='p-label-info'>{telefono}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row m-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                            <div className=''>
                                                <p className='p-label-info'>Este espacio es para ti: si hay algo que quieras que el profesional sepa, escríbelo aquí: <span className='text-opcional-mini'>(Opcional)</span>  </p>
                                                <textarea className='form-control mt-2'
                                                    name='observaciones'
                                                    value={observaciones}
                                                    onChange={changeInput}
                                                    rows={4}
                                                    cols={30}
                                                    placeholder=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className='div-formulario-cliente-step-2'>
                                        <p className='p-label-info-text'>¿Todo listo? Confirma tu cita para finalizar.</p>
                                    </div>
                                    <div className='div-buttoms-formulario-confirma-cita'>
                                        <button className='bottom-custom-secondary' onClick={() => confirmaCitaAgendaTe()} >
                                            Confirmar cita
                                        </button>
                                    </div>
                                    <div className='div-formulario-cliente-step-2'>
                                        <p className='p-label-info my-3'>Al confirmar, recibirás un correo con los detalles de tu cita
                                            y un enlace para modificarla si lo necesitas.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >
            <Modal isOpen={modalInfo} onHide={handleCloseInfo} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>¡Tu cita ha sido agendada! <FontAwesomeIcon icon={faCheckDouble} className='icon-check' /></h4>
                </ModalHeader>
                <ModalBody>
                    <div className="row m-0">
                        <div className="col-12 col-sm-12 col-md-1 col-lg-2" ></div>
                        <div className="col-12 col-sm-12 col-md-1 col-lg-8" >
                            <p>Tu cita ha sido registrada exitosamente.</p>
                            <br />
                            <h5>¿Qué sigue? <FontAwesomeIcon icon={faEnvelopeCircleCheck} className='px-2' /></h5>
                            <p className='mt-2'>En breve recibirás un correo con todos los detalles, incluyendo:</p>
                            <div className='div-detalles-confirmacita'>
                                <p className='text-aling-justify'>- Los detalles completos de tu cita</p>
                                <p className='text-aling-justify'>- Un enlace para modificarla o cancelarla si lo necesitas</p>
                            </div>
                            <h5>Recuerda:<FontAwesomeIcon icon={faBell} className='px-2' /></h5>
                            <p className='mt-2'>Guarda el correo para acceder fácilmente a tu cita más adelante.</p>
                        </div>
                        <div className="col-12 col-sm-12 col-md-1 col-lg-2" ></div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseInfo}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default PerfilesAgendate